import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as actions from '../../actions';
import { Steps } from '../intro.js-react';


class Tutorial extends Component {

  constructor(props) {
    super(props);
    this.domRefs = {};

    this.defaultOptions = {
      disableInteraction: true,
      exitOnEsc: false,
      exitOnOverlayClick: false,
      keyboardNavigation: false,
      hideNext: true,
      showBullets: false,
      showProgress: true,
      showStepNumbers: false,
      tooltipClass: "guide-tooltip"
    }
  }

  onComplete(){
    //move to next lesson
    const { url, length } = this.props.course;

    if(url.id < length){
      const { poet, poem, id } = url;
      const next =  parseInt(id, 10) + 1;
      this.props.history.push("/" + poet + "/" + poem + "/lesson/" + next)
    } else {
      this.props.history.push("/");
    }
  }

  disableButtons(){
    const buttons = document.querySelectorAll('.introjs-button');
    buttons.forEach((button) => {
      button.classList.add('introjs-disabled');
    });

    return buttons;
  }

  addButtonDelay(){
    //Add delay if exists
    const { buttonDelay } = this.props.data;

    if(!buttonDelay)
      return

    const buttons = this.disableButtons();

    setTimeout(() => {
      buttons.forEach((button) => {
        button.classList.remove('introjs-disabled');
      });
    }, buttonDelay);
  }

  onAfterChange(nextStepIndex, nextElement){
    const last = this._steps ? (this._steps.introJs._introItems.length - nextStepIndex) <= 1 : false;
    if(last) this.props.completeLesson();
    const result = this.props.onChange(nextStepIndex, nextElement, this._steps, this.domRefs);

    if(result === 'disable'){
      this.disableButtons();
    } else {
      this.addButtonDelay();
    }
  }

  getSteps(){
    const options = Object.assign(this.defaultOptions, this.props.data.options);
      return (
        <Steps
          enabled = {true}
          autoStart = {true}
          steps = {this.props.data.steps}
          initialStep = {0}
          onExit = {() => this.props.disableGuide()}
          onBeforeChange = {nextStepIndex => {
            if (this.props.data.refreshSteps.includes(nextStepIndex))
              this._steps.updateStepElement(nextStepIndex);
          }}
          onAfterChange = {(nextStepIndex, nextElement) => this.onAfterChange(nextStepIndex, nextElement)}
          options = {options}
          introContainer = {this.props.data.container}
          onComplete = {() => this.onComplete()}
          ref = {(Steps) => this._steps = Steps}
        />
      )
  }

  render(){
    if(!this.props.data || !this.props.onChange)
      return null;
    return (
      <div id="Tutorial">
        {this.getSteps()}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    course: state.course,
    text: state.course.text
  };
}

export default connect(mapStateToProps, actions)(withRouter(Tutorial));



// WEBPACK FOOTER //
// ./src/components/Tutorial/Tutorial.js